export default "/img/compassBg.a2004afe971d8455b87aef9b77025a7c.svg";